// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Order_section_2Obpv{display:grid;grid-template-rows:1fr min-content;width:100%;height:100%}", ""]);
// Exports
exports.locals = {
	"section": "Order_section_2Obpv"
};
module.exports = exports;
